import i18next from "i18next";

class CustomTranslationEngine {
  constructor(account) {
    this.account = account;
    this.excludeKeys = [
      "settings.customization.projects",
      "settings.customization.users",
      "settings.customization.project",
      "settings.customization.user",
      "settings.custom_project_fields",
      "settings.custom_system_names",
      "settings.custom_system_name_tooltip",
      "settings.custom_project_fields_tooltip",
    ];
  }

  languageValues = {
    en: {
      projects: "projects",
      project: "project",
      users: "users",
      user: "user",
    },
    fr: {
      projects: "projets",
      project: "projet",
      users: "utilisateurs",
      user: "utilisateur",
    },
    de: {
      projects: "projekte",
      project: "projekt",
      users: "benutzer",
      user: "benutzer",
    },
    es: {
      projects: "proyectos",
      project: "proyecto",
      users: "usuarios",
      user: "usuario",
    },
    it: {
      projects: "progetti",
      project: "progetto",
      users: "utenti",
      user: "utente",
    },
  };

  getLanguageValue(key) {
    const languageValue = this.languageValues[this.account.language][key];
    return languageValue ? languageValue : key;
  }

  updateTranslationValues() {
    const ALL_TRANSLATIONS = i18next.getResourceBundle(this.account.language, "translation");

    this.account.custom_translations.forEach((customTranslation) => {
      this.deepReplace(ALL_TRANSLATIONS, customTranslation.key, customTranslation.value);
    });
  }

  deepReplace(obj, replacingValue, valueToReplace, currentPath = "") {
    if (!obj) return;

    const lowerCaseReplacingValue = this.getLanguageValue(replacingValue).toLowerCase();
    const regex = new RegExp(`\\b${lowerCaseReplacingValue}\\b`, "gi");

    for (const [k, v] of Object.entries(obj)) {
      const fullPath = currentPath ? `${currentPath}.${k}` : k;

      if (typeof v === "string") {
        if (!this.excludeKeys.includes(fullPath) && v.toLowerCase().includes(lowerCaseReplacingValue)) {
          obj[k] = v.replace(regex, valueToReplace);
        }
      } else if (v && typeof v === "object") {
        this.deepReplace(v, replacingValue, valueToReplace, fullPath);
      }
    }
    return obj;
  }
}

export default CustomTranslationEngine;
